import { configureStore } from '@reduxjs/toolkit';
import themeReducer from './reducers/theme';
import languageReducer from './reducers/language';
import restaurantReducer from './reducers/restaurant';
import hotelReducer from './reducers/hotel';
import spaReducer from './reducers/spa';
import cartReducer from './reducers/cart';
import chainReducer from './reducers/chain';
import { getThemeStore } from '../utils/storage/store';
import { getTheme } from '../utils/theme';

export const store = configureStore({
  reducer: {
    theme: themeReducer,
    language: languageReducer,
    restaurant: restaurantReducer,
    hotel: hotelReducer,
    spa: spaReducer,
    cart: cartReducer,
    chain: chainReducer
  }
});

// 在store创建完成后立即初始化主题样式
const initializeThemeStyles = () => {
  try {
    // 确保DOM已经准备好
    if (typeof document !== 'undefined' && document.documentElement) {
      const savedTheme = getThemeStore();
      if (savedTheme && savedTheme.key) {
        const themeObj = getTheme(savedTheme.key);
        // 设置CSS变量
        document.documentElement.style.setProperty('--adm-color-primary', themeObj.color);
        document.documentElement.style.setProperty('--adm-color-primary-hover', themeObj.otherColor);
        console.log('Theme styles initialized:', themeObj.name);
      }
    }
  } catch (error) {
    console.warn('Failed to initialize theme styles:', error);
  }
};

// 初始化主题样式
initializeThemeStyles();

export default store;